export const seznamVykonnostnichTrid = [
    { key: "D", value: 'D' },
    { key: "C", value: 'C' },
    { key: "B", value: 'B' },
    { key: "A", value: 'A' },
    { key: "M", value: 'M' }
];

export const seznamDisciplin = [
    { key: "S", value: 'Standard' },
    { key: "L", value: 'Latina' }
];

export const seznamUmisteniVeFinale = [
    { key: "true", value: 'Ano' },
    { key: "false", value: 'Ne' }
];

export const seznamPoctuKolClenu = [
    { key: "1", value: '1' },
    { key: "2", value: '2' },
    { key: "3", value: '3 a více' }
];

export const seznamVekovychKategorii = [
    { key: "D1", value: 'Děti I.' },
    { key: "D2", value: 'Děti II.' },
    { key: "J1", value: 'Junior I.' },
    { key: "J2", value: 'Junior II.' },
    { key: "ML", value: 'Mládež' },
    { key: "DS", value: 'Dospělí' },
    { key: "S1", value: 'Senior I.' },
    { key: "S2", value: 'Senior II.' },
    { key: "S3", value: 'Senior III.' },
    { key: "S4", value: 'Senior IV.' }
];